/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Сообщение об ошибке
 */
export interface ErrorMessage {
  /** @format date-time */
  timestamp?: string;

  /** @format int32 */
  status?: number;
  error?: string;
  path?: string;
}

/**
 * Объект со значениями данных кастомного поля при добавлении данных
 */
export interface EavFieldValueItemToAdd {
  /** @format uuid */
  fieldId?: string;
  val?: string;
}

/**
 * Запрос для редактирования сделки
 */
export interface TaskUpdateRequest {
  /**
   * Идентификатор задачи
   * @format uuid
   */
  id: string;

  /** Наименование задачи */
  name: string;

  /**
   * Колонка
   * @format uuid
   */
  columnId: string;

  /**
   * Дата выполнения (дедлайн)
   * @format date
   */
  deadline?: string;

  /**
   * Дата и время начала выполнения
   * @format date-time
   */
  startDate?: string;

  /**
   * Дата и время окончания выполнения
   * @format date-time
   */
  endDate?: string;

  /**
   * Ссылка на сделку
   * @format uuid
   */
  dealId?: string;

  /** Признак важности задачи */
  isImportant?: boolean;

  /** Массив идентификаторов контактов - для установления связей */
  contactIds?: string[];

  /** Комментарий */
  comment?: string;

  /** Кастомные поля */
  customFields?: EavFieldValueItemToAdd[];
}

/**
 * Ответ при успешном создании/обновлении задачи
 */
export interface TaskCreationResponse {
  /** @format uuid */
  crmClientId?: string;

  /** @format uuid */
  taskId?: string;
}

export interface EavFieldItemToUpdate {
  /** @format uuid */
  id: string;
  name: string;
  isRequired: boolean;

  /**
   * @format int32
   * @min 0
   */
  position: number;
}

/**
 * Запрос при обновлении пользовательских полей
 */
export interface EavFieldUpdateRequest {
  /** @format uuid */
  entityId: string;
  fields: EavFieldItemToUpdate[];
}

/**
 * Ответ при создании / добавлении / удалении пользовательских полей
 */
export interface EavFieldCommonResponse {
  /** @format uuid */
  crmClientId?: string;

  /** @format uuid */
  entityId?: string;
}

/**
 * Запрос при редактировании товара / услуги
 */
export interface ProductAndServiceUpdateRequest {
  /**
   * Идентификатор типа товара или услуги
   * @format uuid
   */
  id: string;

  /**
   * Идентификатор ед. изм.
   * @format uuid
   */
  measureUnitId?: string;

  /**
   * Идентификатор ед. изм. продолжительности
   * @format uuid
   */
  durationMeasureId?: string;

  /** Наименование */
  name: string;

  /**
   * Продолжительность
   * @format int32
   */
  duration?: number;

  /** Описание */
  description?: string;

  /** Цена */
  price?: number;

  /** Кастомные поля */
  customFields?: EavFieldValueItemToAdd[];
}

/**
 * Ответ при создании и редактировании товара / услуги
 */
export interface ProductAndServiceCreationResponse {
  /** @format uuid */
  crmClientId?: string;

  /** @format uuid */
  productServiceId?: string;
}

/**
 * Запрос для редактирования сделки
 */
export interface DealUpdateRequest {
  /**
   * Идентификатор сделки
   * @format uuid
   */
  id: string;

  /** Наименование сделки */
  name: string;

  /** Бюджет */
  budget?: number;

  /**
   * Колонка
   * @format uuid
   */
  columnId: string;

  /**
   * Статус
   * @format uuid
   */
  stateId: string;

  /** Описание */
  mark?: string;

  /**
   * Дедлайн
   * @format date
   */
  deadline?: string;

  /** Признак активности сделки */
  isActive: boolean;

  /** Массив идентификаторов товаров и услуг */
  productAndServiceIds?: string[];

  /** Массив идентификаторов контактов */
  contactIds?: string[];

  /** Массив идентификаторов задач */
  taskIds?: string[];

  /** Кастомные поля */
  customFields?: EavFieldValueItemToAdd[];

  /**
   * Приоритет сделки
   * @format int32
   * @min 0
   * @max 3
   */
  priority?: number;
}

/**
 * Ответ при успешном создании/обновлении сделки
 */
export interface DealCreationResponse {
  /** @format uuid */
  crmClientId?: string;

  /** @format uuid */
  dealId?: string;
}

/**
 * Запрос при редактировании колонки
 */
export interface DealColumnUpdateRequest {
  /**
   * Идентификатор колонки
   * @format uuid
   */
  id: string;

  /** Наименование */
  name: string;
}

/**
 * Ответ при успешном добавлении/обновлении колонки
 */
export interface DealColumnCreationResponse {
  /** @format uuid */
  crmClientId?: string;

  /** @format uuid */
  columnId?: string;
}

/**
 * Запрос для редактирования контакта
 */
export interface ContactUpdateRequest {
  /**
   * Идентификатор контакта
   * @format uuid
   */
  id: string;

  /** ФИО */
  name: string;

  /** Город */
  city?: string;

  /** Компания */
  companyName?: string;

  /** Электронная почта */
  email?: string;

  /** Телефон */
  phone?: string;

  /** Дополнительая информация */
  additionalInfo?: string;

  /** Кастомные поля */
  customFields?: EavFieldValueItemToAdd[];
}

/**
 * Ответ при успешном создании/обновлении контакта
 */
export interface ContactCreationResponse {
  /** @format uuid */
  crmClientId?: string;

  /** @format uuid */
  contactId?: string;
}

/**
 * Запрос для редактирования комментария к сделке
 */
export interface DealCommentUpdateRequest {
  /**
   * Идентификатор комментария
   * @format uuid
   */
  id: string;

  /** Текст комментария */
  comment: string;

  /**
   * Ссылка на сделку
   * @format uuid
   */
  dealId?: string;
}

/**
 * Ответ при успешном добавлении/обновлении комментария к сделке
 */
export interface DealCommentCreationResponse {
  /** @format uuid */
  crmClientId?: string;

  /** @format uuid */
  commentId?: string;
}

/**
 * Запрос при создании задачи
 */
export interface TaskCreationRequest {
  /** Наименование задачи */
  name: string;

  /**
   * Колонка
   * @format uuid
   */
  columnId: string;

  /**
   * Дата выполнения (дедлайн)
   * @format date
   */
  deadline?: string;

  /**
   * Дата и время начала выполнения
   * @format date-time
   */
  startDate?: string;

  /**
   * Дата и время окончания выполнения
   * @format date-time
   */
  endDate?: string;

  /** Признак важности задачи */
  isImportant?: boolean;

  /**
   * Ссылка на сделку
   * @format uuid
   */
  dealId?: string;

  /** Ссылки на контакты */
  contactIds?: string[];

  /** Кастомные поля */
  customFields?: EavFieldValueItemToAdd[];
}

/**
 * Запрос при добавлении пользовательских полей
 */
export interface EavFieldCreationRequest {
  /** @format uuid */
  entityId: string;
  fields: EavFieldItemToAdd[];
}

export interface EavFieldItemToAdd {
  name: string;
  type: string;

  /**
   * @format int32
   * @min 1
   */
  size?: number;
  isRequired: boolean;

  /**
   * @format int32
   * @min 0
   */
  position: number;
}

/**
 * Запрос при создании товара / услуги
 */
export interface ProductAndServiceCreationRequest {
  /**
   * Идентификатор типа товара или услуги
   * @format uuid
   */
  typeId: string;

  /**
   * Идентификатор ед. изм.
   * @format uuid
   */
  measureUnitId?: string;

  /**
   * Идентификатор ед. изм. продолжительности
   * @format uuid
   */
  durationMeasureId?: string;

  /** Наименование */
  name: string;

  /**
   * Продолжительность
   * @format int32
   */
  duration?: number;

  /** Описание */
  description?: string;

  /** Цена */
  price?: number;

  /** Кастомные поля */
  customFields?: EavFieldValueItemToAdd[];
}

/**
 * Запрос при добавлении колонки
 */
export interface DealColumnCreationRequest {
  /** Наименование */
  name: string;
}

/**
 * Запрос при создании сделки
 */
export interface DealCreationRequest {
  /** МС-инициатор создания сделки */
  sourceSystem?: string;

  /**
   * Идентификатор чека по сделке
   * @format int64
   */
  incomeId?: number;

  /** Наименование сделки */
  name: string;

  /** Бюджет */
  budget?: number;

  /**
   * Колонка
   * @format uuid
   */
  columnId: string;

  /**
   * Статус
   * @format uuid
   */
  stateId?: string;

  /** Описание */
  mark?: string;

  /**
   * Дедлайн
   * @format date
   */
  deadline?: string;

  /** Массив идентификаторов товаров и услуг */
  productAndServiceIds?: string[];

  /** Массив идентификаторов контактов */
  contactIds?: string[];

  /** Массив идентификаторов задач */
  taskIds?: string[];

  /** Кастомные поля */
  customFields?: EavFieldValueItemToAdd[];

  /**
   * Приоритет сделки
   * @format int32
   * @min 0
   * @max 3
   */
  priority?: number;
}

/**
 * Запрос при создании контакта
 */
export interface ContactCreationRequest {
  /** ФИО */
  name: string;

  /** Город */
  city?: string;

  /** Компания */
  companyName?: string;

  /** Электронная почта */
  email?: string;

  /** Телефон */
  phone?: string;

  /** Дополнительая информация */
  additionalInfo?: string;

  /** Кастомные поля */
  customFields?: EavFieldValueItemToAdd[];
}

/**
 * Запрос при добавлении комментария к сделке
 */
export interface DealCommentCreationRequest {
  /** Текст комментария */
  comment: string;

  /**
   * Ссылка на сделку
   * @format uuid
   */
  dealId: string;
}

/**
 * Пагинация
 */
export interface PaginationInfo {
  /** @format int64 */
  size?: number;

  /** @format int64 */
  totalElements?: number;

  /** @format int64 */
  totalPages?: number;

  /** @format int64 */
  number?: number;
}

export interface TaskItem {
  /** @format uuid */
  id?: string;

  /** @format uuid */
  columnId?: string;
  columnName?: string;
  name?: string;

  /** @format date */
  deadLine?: string;

  /** @format date-time */
  startDate?: string;

  /** @format date-time */
  endDate?: string;

  /** @format date-time */
  createDate?: string;

  /** @format date-time */
  updateDate?: string;
  isExpired?: boolean;
  isImportant?: boolean;
}

/**
 * Страница с данными о задачах
 */
export interface TaskPageResponse {
  /** @format uuid */
  crmClientId?: string;
  data?: TaskItem[];

  /** Пагинация */
  page?: PaginationInfo;
}

export interface TaskSearchData {
  /** @format uuid */
  id?: string;
  name?: string;
}

/**
 * Ответ при поиске задачи
 */
export interface TaskSearchResponse {
  /** @format uuid */
  crmClientId?: string;
  data?: TaskSearchData[];
}

/**
 * Ответ со счетчиками статусов задач
 */
export interface TaskCounterResponse {
  /** @format uuid */
  crmClientId?: string;

  /** @format int64 */
  numberOfNew?: number;

  /** @format int64 */
  numberOfInProgress?: number;

  /** @format int64 */
  numberOfDone?: number;

  /** @format int64 */
  numberOfActual?: number;

  /** @format int64 */
  numberOfExpired?: number;
}

export interface TaskColumnData {
  /** @format uuid */
  id?: string;
  name?: string;
}

/**
 * Колонка задачи
 */
export interface TaskColumnResponse {
  /** @format uuid */
  crmClientId?: string;
  data?: TaskColumnData[];
}

/**
 * Контакт (в списке сделок и задач)
 */
export interface ContactBasicResponse {
  /** @format uuid */
  id?: string;
  name?: string;
  email?: string;
  phone?: string;
}

/**
 * Объект со значениями данных кастомного поля
 */
export interface CustomFieldsValueItem {
  /** @format uuid */
  fieldId?: string;
  fieldName?: string;
  val?: string;

  /** @format int32 */
  position?: number;
}

/**
 * Сделка (данные внутри задачи)
 */
export interface DealShortResponse {
  /** @format uuid */
  id?: string;
  name?: string;
}

/**
 * Карточка задачи
 */
export interface TaskCardItem {
  /** @format uuid */
  id?: string;

  /** @format uuid */
  crmResponsibleId?: string;
  responsibleName?: string;

  /** @format uuid */
  columnId?: string;
  columnName?: string;
  name?: string;

  /** @format date */
  deadline?: string;

  /** @format date-time */
  startDate?: string;

  /** @format date-time */
  endDate?: string;

  /** @format date-time */
  createDate?: string;

  /** @format date-time */
  updateDate?: string;
  isExpired?: boolean;
  isImportant?: boolean;
  comment?: string;
  customFields?: CustomFieldsValueItem[];
}

/**
 * Карточка задачи
 */
export interface TaskCardResponse {
  /** @format uuid */
  crmClientId?: string;

  /** Карточка задачи */
  taskData?: TaskCardItem;
  contactData?: ContactBasicResponse[];

  /** Сделка (данные внутри задачи) */
  dealData?: DealShortResponse;
}

/**
 * Информация о сущности
 */
export interface EavEntityItem {
  /** @format uuid */
  id?: string;
  name?: string;
  isBasic?: boolean;
}

/**
 * Ответ с доступным списком сущностей
 */
export interface EavEntityListResponse {
  /** @format uuid */
  crmClientId?: string;
  data?: EavEntityItem[];
}

/**
 * Товар/услуга
 */
export interface ProductAndService {
  /** @format uuid */
  id?: string;

  /** @format uuid */
  typeId?: string;
  typeName?: string;

  /** @format uuid */
  measureUnitId?: string;
  measureUnitName?: string;

  /** @format uuid */
  durationMeasureId?: string;
  durationMeasureName?: string;
  isPublishable?: boolean;

  /** @format uuid */
  crmResponsibleId?: string;

  /** @format date-time */
  updateDate?: string;

  /** @format date-time */
  createDate?: string;
  name?: string;

  /** @format int32 */
  duration?: number;
  description?: string;
  price?: number;
}

/**
 * Страница с данными о товарах и услугах
 */
export interface ProductAndServicePage {
  /** @format uuid */
  crmClientId?: string;
  hasMore?: boolean;
  data?: ProductAndService[];

  /** Пагинация */
  page?: PaginationInfo;
}

/**
 * Типы товаров и услуг
 */
export interface ProductAndServiceType {
  /** @format uuid */
  crmClientId?: string;
  data?: ProductAndServiceTypeData[];
}

export interface ProductAndServiceTypeData {
  /** @format uuid */
  id?: string;
  name?: string;
}

export interface ProductAndServiceSearchData {
  /** @format uuid */
  id?: string;
  name?: string;
}

/**
 * Ответ при поиске товаров и услуг
 */
export interface ProductAndServiceSearchResponse {
  /** @format uuid */
  crmClientId?: string;
  data?: ProductAndServiceSearchData[];
}

/**
 * Единицы измерений товаров и услуг
 */
export interface ProductAndServiceMeasureUnit {
  /** @format uuid */
  crmClientId?: string;
  data?: ProductAndServiceMeasureUnitData[];
}

export interface ProductAndServiceMeasureUnitData {
  /** @format uuid */
  id?: string;
  shortName?: string;
  name?: string;
}

/**
 * Единицы измерений продолжительности услуг
 */
export interface ProductAndServiceDurationMeasure {
  /** @format uuid */
  crmClientId?: string;
  data?: ProductAndServiceDurationMeasureData[];
}

export interface ProductAndServiceDurationMeasureData {
  /** @format uuid */
  id?: string;
  shortName?: string;
  name?: string;
}

/**
 * Товар/услуга (базовые данные)
 */
export interface ProductAndServiceBasic {
  /** @format uuid */
  id?: string;

  /** @format uuid */
  typeId?: string;
  typeName?: string;

  /** @format uuid */
  measureUnitId?: string;
  measureUnitName?: string;

  /** @format uuid */
  durationMeasureId?: string;
  durationMeasureName?: string;

  /** @format date-time */
  updateDate?: string;

  /** @format date-time */
  createDate?: string;
  name?: string;

  /** @format int32 */
  duration?: number;
  description?: string;
  price?: number;
  customFields?: CustomFieldsValueItem[];
}

/**
 * Карточка товара / услуги
 */
export interface ProductAndServiceCard {
  /** @format uuid */
  crmClientId?: string;

  /** Товар/услуга (базовые данные) */
  data?: ProductAndServiceBasic;
}

/**
 * Сделка (когда возвращаем несколько)
 */
export interface DealBasic {
  sourceSystem?: string;

  /** @format uuid */
  id?: string;

  /** @format uuid */
  crmResponsibleId?: string;
  responsibleName?: string;

  /** @format int64 */
  incomeId?: number;

  /** @format uuid */
  columnId?: string;
  columnName?: string;
  name?: string;

  /** @format date */
  deadline?: string;

  /** @format uuid */
  stateId?: string;
  stateName?: string;
  budget?: number;

  /** @format date-time */
  createDate?: string;

  /** @format date-time */
  updateDate?: string;
  isActive?: boolean;
  hasTasks?: boolean;

  /** @format int32 */
  priority?: number;
  taskData?: TaskInfoResponse[];
}

/**
 * Страница с данными о сделках
 */
export interface DealPage {
  /** @format uuid */
  crmClientId?: string;
  data?: DealBasic[];

  /** Пагинация */
  page?: PaginationInfo;
}

/**
 * Данные о задачах связанных со сделкой
 */
export interface TaskInfoResponse {
  /** @format uuid */
  id?: string;
  name?: string;

  /** @format uuid */
  columnId?: string;
  columnName?: string;
  isExpired?: boolean;
  isImportant?: boolean;
}

/**
 * Статус сделки
 */
export interface DealState {
  /** @format uuid */
  crmClientId?: string;
  data?: DealStateData[];
}

export interface DealStateData {
  /** @format uuid */
  id?: string;
  name?: string;

  /** @format uuid */
  columnId?: string;
}

export interface DealSearchData {
  /** @format uuid */
  id?: string;
  name?: string;
}

/**
 * Ответ при поиске сделки
 */
export interface DealSearchResponse {
  /** @format uuid */
  crmClientId?: string;
  data?: DealSearchData[];
}

export interface DealColumnItem {
  /** @format uuid */
  id?: string;
  name?: string;

  /** @format int64 */
  count?: number;
}

/**
 * Ответ со счетчиками статусов сделок
 */
export interface DealCounterResponse {
  /** @format uuid */
  crmClientId?: string;

  /** @format int64 */
  numberOfNew?: number;

  /** @format int64 */
  numberOfInProgress?: number;

  /** @format int64 */
  numberOfDone?: number;
  customColumns?: DealColumnItem[];

  /** @format int64 */
  numberOfActual?: number;

  /** @format int64 */
  numberOfArchived?: number;
}

/**
 * Колонка сделки
 */
export interface DealColumn {
  /** @format uuid */
  crmClientId?: string;
  data?: DealColumnData[];
}

export interface DealColumnData {
  /** @format uuid */
  id?: string;
  name?: string;
  isBasic?: boolean;
}

/**
 * Сделка (когда возвращаем в одном экземпляре)
 */
export interface Deal {
  sourceSystem?: string;

  /** @format uuid */
  id?: string;

  /** @format uuid */
  crmResponsibleId?: string;
  responsibleName?: string;

  /** @format int64 */
  incomeId?: number;

  /** @format uuid */
  columnId?: string;
  columnName?: string;
  name?: string;

  /** @format date */
  deadline?: string;

  /** @format uuid */
  stateId?: string;
  stateName?: string;
  budget?: number;

  /** @format date-time */
  createDate?: string;

  /** @format date-time */
  updateDate?: string;
  isActive?: boolean;
  mark?: string;
  customFields?: CustomFieldsValueItem[];

  /** @format int32 */
  priority?: number;
}

/**
 * Карточка сделки
 */
export interface DealCard {
  /** @format uuid */
  crmClientId?: string;

  /** Сделка (когда возвращаем в одном экземпляре) */
  dealData?: Deal;
  productAndServiceData?: ProductAndServiceBasic[];
  contactData?: ContactBasicResponse[];
  taskData?: TaskBasicResponse[];
}

/**
 * Задача (базовая информация)
 */
export interface TaskBasicResponse {
  /** @format uuid */
  id?: string;

  /** @format uuid */
  columnId?: string;
  name?: string;

  /** @format date */
  deadline?: string;

  /** @format date-time */
  startDate?: string;

  /** @format date-time */
  endDate?: string;
  isExpired?: boolean;
  isImportant?: boolean;
}

export interface ContactItem {
  /** @format uuid */
  id?: string;
  name?: string;
  city?: string;
  companyName?: string;
  email?: string;
  phone?: string;
  additionalInfo?: string;

  /** @format date-time */
  createDate?: string;

  /** @format date-time */
  updateDate?: string;
}

/**
 * Страница с данными о контактах
 */
export interface ContactPageResponse {
  /** @format uuid */
  crmClientId?: string;
  data?: ContactItem[];

  /** Пагинация */
  page?: PaginationInfo;
}

export interface ContactSearchData {
  /** @format uuid */
  id?: string;
  name?: string;
}

/**
 * Ответ при поиске контактов
 */
export interface ContactSearchResponse {
  /** @format uuid */
  crmClientId?: string;
  data?: ContactSearchData[];
}

/**
 * Контакт
 */
export interface Contact {
  /** @format uuid */
  id?: string;

  /** @format uuid */
  crmResponsibleId?: string;
  responsibleName?: string;
  name?: string;
  city?: string;

  /** @format date-time */
  createDate?: string;

  /** @format date-time */
  updateDate?: string;
  companyName?: string;
  email?: string;
  phone?: string;
  additionalInfo?: string;
  customFields?: CustomFieldsValueItem[];
}

/**
 * Карточка контакта
 */
export interface ContactCard {
  /** @format uuid */
  crmClientId?: string;

  /** Контакт */
  contactData?: Contact;
}

export interface DealCommentItem {
  /** @format uuid */
  id?: string;
  comment?: string;

  /** @format date-time */
  createDate?: string;

  /** @format date-time */
  updateDate?: string;
}

/**
 * Страница с данными о комментариях к сделкам
 */
export interface DealCommentPageResponse {
  /** @format uuid */
  crmClientId?: string;
  data?: DealCommentItem[];
}

/**
 * Комментарий к сделке
 */
export interface DealComment {
  /** @format uuid */
  id?: string;

  /** @format uuid */
  crmResponsibleId?: string;
  responsibleName?: string;
  comment?: string;

  /** @format date-time */
  createDate?: string;

  /** @format date-time */
  updateDate?: string;
}

/**
 * Карточка комментария к сделке
 */
export interface DealCommentCard {
  /** @format uuid */
  crmClientId?: string;

  /** Комментарий к сделке */
  commentData?: DealComment;
}

/**
 * Запрос при удалении задач
 */
export interface TaskDeletionRequest {
  /** Идентификаторы задач */
  taskIds: string[];
}

/**
 * Ответ при успешном удалении задачи
 */
export interface TaskDeletionResponse {
  /** @format uuid */
  crmClientId?: string;
}

/**
 * Запрос при удалении пользовательских полей
 */
export interface EavFieldDeletionRequest {
  /** @format uuid */
  entityId: string;
  fieldIds: string[];
}

/**
 * Запрос при удалении товара / услуги
 */
export interface ProductAndServiceDeletionRequest {
  /** Массив идентификаторов товаров / услуг */
  productsServicesIds: string[];
}

/**
 * Ответ при удалении товара / услуги
 */
export interface ProductAndServiceDeletionResponse {
  /** @format uuid */
  crmClientId?: string;
}

/**
 * Запрос при удалении сделок
 */
export interface DealDeletion {
  /** Идентификаторы сделок */
  dealsId: string[];
}

/**
 * Ответ при успешном удалении сделки
 */
export interface DealDeletionResponse {
  /** @format uuid */
  crmClientId?: string;
}

/**
 * Запрос при удалении колонок
 */
export interface DealColumnDeletionRequest {
  /** Массив идентификаторов колонок */
  columnIds: string[];
}

/**
 * Ответ при успешном удалении колонок
 */
export interface DealColumnDeletionResponse {
  /** @format uuid */
  crmClientId?: string;
}

/**
 * Запрос при удалении контактов
 */
export interface ContactDeletionRequest {
  /** Идентификаторы задач */
  contactIds: string[];
}

/**
 * Ответ при успешном удалении контакта
 */
export interface ContactDeletionResponse {
  /** @format uuid */
  crmClientId?: string;
}

/**
 * Запрос при удалении комментариев к сделке
 */
export interface DealCommentDeletionRequest {
  /** Массив идентификаторов комментариев */
  commentIds: string[];
}

/**
 * Ответ при успешном удалении комментариев к сделкам
 */
export interface DealCommentDeletionResponse {
  /** @format uuid */
  crmClientId?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис crm-ms-prd-core
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://crm-ms-prd-core.crmdbo.dev.rshbdev.ru
 * @contact https://sdlc.go.rshbank.ru/jira/projects/OB_SAAS <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=196385940)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Задачи
     * @name UpdateTask
     * @summary Редактирование задачи
     * @request PUT:/api/crm/external/v1/tasks/edit
     */
    updateTask: (data: TaskUpdateRequest, params: RequestParams = {}) =>
      this.request<TaskCreationResponse, ErrorMessage>({
        path: `/api/crm/external/v1/tasks/edit`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Пользовательские поля
     * @name GetCustomFields
     * @summary Получение структуры пользовательских полей
     * @request GET:/api/crm/external/v1/eav/custom-fields
     */
    getCustomFields: (
      query: { entityId: string },
      params: RequestParams = {}
    ) =>
      this.request<EavFieldCommonResponse, ErrorMessage>({
        path: `/api/crm/external/v1/eav/custom-fields`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Пользовательские поля
     * @name UpdateCustomFields
     * @summary Редактирование пользовательских полей в структуре
     * @request PUT:/api/crm/external/v1/eav/custom-fields
     */
    updateCustomFields: (
      data: EavFieldUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.request<EavFieldCommonResponse, ErrorMessage>({
        path: `/api/crm/external/v1/eav/custom-fields`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Пользовательские поля
     * @name CreateCustomFields
     * @summary Добавление пользовательских полей в структуру
     * @request POST:/api/crm/external/v1/eav/custom-fields
     */
    createCustomFields: (
      data: EavFieldCreationRequest,
      params: RequestParams = {}
    ) =>
      this.request<EavFieldCommonResponse, ErrorMessage>({
        path: `/api/crm/external/v1/eav/custom-fields`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Пользовательские поля
     * @name DeleteCustomFields
     * @summary Удаление пользовательских полей из структуры
     * @request DELETE:/api/crm/external/v1/eav/custom-fields
     */
    deleteCustomFields: (
      data: EavFieldDeletionRequest,
      params: RequestParams = {}
    ) =>
      this.request<EavFieldCommonResponse, ErrorMessage>({
        path: `/api/crm/external/v1/eav/custom-fields`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Товары и услуги
     * @name UpdateProductAndService
     * @summary Редактирование товара / услуги
     * @request PUT:/api/crm/external/v1/dict/products-and-services/edit
     */
    updateProductAndService: (
      data: ProductAndServiceUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.request<ProductAndServiceCreationResponse, ErrorMessage>({
        path: `/api/crm/external/v1/dict/products-and-services/edit`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name UpdateDeal
     * @summary Редактирование сделки
     * @request PUT:/api/crm/external/v1/deals/edit
     */
    updateDeal: (data: DealUpdateRequest, params: RequestParams = {}) =>
      this.request<DealCreationResponse, ErrorMessage>({
        path: `/api/crm/external/v1/deals/edit`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name GetDealColumns
     * @summary Получение списка колонок сделки
     * @request GET:/api/crm/external/v1/deals/columns
     */
    getDealColumns: (params: RequestParams = {}) =>
      this.request<DealColumn, ErrorMessage>({
        path: `/api/crm/external/v1/deals/columns`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name UpdateDealColumn
     * @summary Редактирование колонки сделки
     * @request PUT:/api/crm/external/v1/deals/columns
     */
    updateDealColumn: (
      data: DealColumnUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.request<DealColumnCreationResponse, ErrorMessage>({
        path: `/api/crm/external/v1/deals/columns`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name CreateDealColumn
     * @summary Добавление колонки сделки
     * @request POST:/api/crm/external/v1/deals/columns
     */
    createDealColumn: (
      data: DealColumnCreationRequest,
      params: RequestParams = {}
    ) =>
      this.request<DealColumnCreationResponse, ErrorMessage>({
        path: `/api/crm/external/v1/deals/columns`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name DeleteDealColumns
     * @summary Удаление колонок сделки
     * @request DELETE:/api/crm/external/v1/deals/columns
     */
    deleteDealColumns: (
      data: DealColumnDeletionRequest,
      params: RequestParams = {}
    ) =>
      this.request<DealColumnDeletionResponse, ErrorMessage>({
        path: `/api/crm/external/v1/deals/columns`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name UpdateColumnId
     * @summary Изменение колонки сделки
     * @request PUT:/api/crm/external/v1/deals/column/edit
     */
    updateColumnId: (
      query: { id: string; columnId: string },
      params: RequestParams = {}
    ) =>
      this.request<DealCreationResponse, ErrorMessage>({
        path: `/api/crm/external/v1/deals/column/edit`,
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name UpdateIsActive
     * @summary Архивирование / восстановление сделки
     * @request PUT:/api/crm/external/v1/deals/active/edit
     */
    updateIsActive: (
      query: { id: string; isActive: boolean },
      params: RequestParams = {}
    ) =>
      this.request<DealCreationResponse, ErrorMessage>({
        path: `/api/crm/external/v1/deals/active/edit`,
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Контакты
     * @name UpdateContact
     * @summary Редактирование контакта
     * @request PUT:/api/crm/external/v1/contacts/edit
     */
    updateContact: (data: ContactUpdateRequest, params: RequestParams = {}) =>
      this.request<ContactCreationResponse, ErrorMessage>({
        path: `/api/crm/external/v1/contacts/edit`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Комментарии
     * @name UpdateComment
     * @summary Редактирование комментария к сделке
     * @request PUT:/api/crm/external/v1/comments/edit
     */
    updateComment: (
      data: DealCommentUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.request<DealCommentCreationResponse, ErrorMessage>({
        path: `/api/crm/external/v1/comments/edit`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Задачи
     * @name CreateTask
     * @summary Создание задачи
     * @request POST:/api/crm/external/v1/tasks/add
     */
    createTask: (data: TaskCreationRequest, params: RequestParams = {}) =>
      this.request<TaskCreationResponse, ErrorMessage>({
        path: `/api/crm/external/v1/tasks/add`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Товары и услуги
     * @name CreateProductAndService
     * @summary Создание товара / услуги
     * @request POST:/api/crm/external/v1/dict/products-and-services/create
     */
    createProductAndService: (
      data: ProductAndServiceCreationRequest,
      params: RequestParams = {}
    ) =>
      this.request<ProductAndServiceCreationResponse, ErrorMessage>({
        path: `/api/crm/external/v1/dict/products-and-services/create`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name CreateDeal
     * @summary Создание сделки
     * @request POST:/api/crm/external/v1/deals/add
     */
    createDeal: (data: DealCreationRequest, params: RequestParams = {}) =>
      this.request<DealCreationResponse, ErrorMessage>({
        path: `/api/crm/external/v1/deals/add`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Контакты
     * @name CreateContact
     * @summary Создание контакта
     * @request POST:/api/crm/external/v1/contacts/add
     */
    createContact: (data: ContactCreationRequest, params: RequestParams = {}) =>
      this.request<ContactCreationResponse, ErrorMessage>({
        path: `/api/crm/external/v1/contacts/add`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Комментарии
     * @name CreateComment
     * @summary Добавление комментария к сделке
     * @request POST:/api/crm/external/v1/comments/add
     */
    createComment: (
      data: DealCommentCreationRequest,
      params: RequestParams = {}
    ) =>
      this.request<DealCommentCreationResponse, ErrorMessage>({
        path: `/api/crm/external/v1/comments/add`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Задачи
     * @name GetTaskPage
     * @summary Получение списка задач
     * @request GET:/api/crm/external/v1/tasks
     */
    getTaskPage: (
      query?: {
        page?: number;
        size?: number;
        isExpired?: boolean;
        columnId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TaskPageResponse, ErrorMessage>({
        path: `/api/crm/external/v1/tasks`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Задачи
     * @name SearchTask
     * @summary Поиск задачи для добавления к сделке
     * @request GET:/api/crm/external/v1/tasks/search/{substring}
     */
    searchTask: (substring: string, params: RequestParams = {}) =>
      this.request<TaskSearchResponse, ErrorMessage>({
        path: `/api/crm/external/v1/tasks/search/${substring}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Задачи
     * @name GetTaskCounters
     * @summary Получение количества задач по колонкам и статусам (счетчики)
     * @request GET:/api/crm/external/v1/tasks/count
     */
    getTaskCounters: (params: RequestParams = {}) =>
      this.request<TaskCounterResponse, ErrorMessage>({
        path: `/api/crm/external/v1/tasks/count`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Задачи
     * @name GetTaskColumns
     * @summary Получение списка колонок задач
     * @request GET:/api/crm/external/v1/tasks/columns
     */
    getTaskColumns: (params: RequestParams = {}) =>
      this.request<TaskColumnResponse, ErrorMessage>({
        path: `/api/crm/external/v1/tasks/columns`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Задачи
     * @name GetTaskCard
     * @summary Получение карточки задачи
     * @request GET:/api/crm/external/v1/tasks/card
     */
    getTaskCard: (query: { id: string }, params: RequestParams = {}) =>
      this.request<TaskCardResponse, ErrorMessage>({
        path: `/api/crm/external/v1/tasks/card`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Пользовательские поля
     * @name GetEntities
     * @summary Получение списка сущностей
     * @request GET:/api/crm/external/v1/eav/entities
     */
    getEntities: (params: RequestParams = {}) =>
      this.request<EavEntityListResponse, ErrorMessage>({
        path: `/api/crm/external/v1/eav/entities`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Товары и услуги
     * @name GetProductAndServicePage
     * @summary Получение списка товаров и услуг
     * @request GET:/api/crm/external/v1/dict/products-and-services
     */
    getProductAndServicePage: (
      query?: { page?: number; size?: number; dealId?: string; id?: string[] },
      params: RequestParams = {}
    ) =>
      this.request<ProductAndServicePage, ErrorMessage>({
        path: `/api/crm/external/v1/dict/products-and-services`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Товары и услуги
     * @name GetProductAndServiceTypes
     * @summary Получение списка типов товаров и услуг
     * @request GET:/api/crm/external/v1/dict/products-and-services/types
     */
    getProductAndServiceTypes: (params: RequestParams = {}) =>
      this.request<ProductAndServiceType, ErrorMessage>({
        path: `/api/crm/external/v1/dict/products-and-services/types`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Товары и услуги
     * @name SearchProductAndService
     * @summary Поиск товаров и услуг
     * @request GET:/api/crm/external/v1/dict/products-and-services/search/{substring}
     */
    searchProductAndService: (substring: string, params: RequestParams = {}) =>
      this.request<ProductAndServiceSearchResponse, ErrorMessage>({
        path: `/api/crm/external/v1/dict/products-and-services/search/${substring}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Товары и услуги
     * @name GetProductAndServiceMeasureUnits
     * @summary Получение списка единиц измерений товаров и услуг
     * @request GET:/api/crm/external/v1/dict/products-and-services/measure-unit
     */
    getProductAndServiceMeasureUnits: (params: RequestParams = {}) =>
      this.request<ProductAndServiceMeasureUnit, ErrorMessage>({
        path: `/api/crm/external/v1/dict/products-and-services/measure-unit`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Товары и услуги
     * @name GetProductAndServiceDurationMeasures
     * @summary Получение списка единиц измерений длительности услуг
     * @request GET:/api/crm/external/v1/dict/products-and-services/duration-measures
     */
    getProductAndServiceDurationMeasures: (params: RequestParams = {}) =>
      this.request<ProductAndServiceDurationMeasure, ErrorMessage>({
        path: `/api/crm/external/v1/dict/products-and-services/duration-measures`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Товары и услуги
     * @name GetProductAndServiceCard
     * @summary Получение карточки товара / услуги
     * @request GET:/api/crm/external/v1/dict/products-and-services/card/{id}
     */
    getProductAndServiceCard: (id: string, params: RequestParams = {}) =>
      this.request<ProductAndServiceCard, ErrorMessage>({
        path: `/api/crm/external/v1/dict/products-and-services/card/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name GetDealPage
     * @summary Получение списка сделок
     * @request GET:/api/crm/external/v1/deals
     */
    getDealPage: (
      query?: {
        page?: number;
        size?: number;
        isActive?: boolean;
        columnId?: string;
        incomeId?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<DealPage, ErrorMessage>({
        path: `/api/crm/external/v1/deals`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name GetDealStates
     * @summary Получение списка статусов сделки
     * @request GET:/api/crm/external/v1/deals/states
     */
    getDealStates: (params: RequestParams = {}) =>
      this.request<DealState, ErrorMessage>({
        path: `/api/crm/external/v1/deals/states`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name SearchDeal
     * @summary Поиск сделки для добавления к задаче
     * @request GET:/api/crm/external/v1/deals/search/{substring}
     */
    searchDeal: (substring: string, params: RequestParams = {}) =>
      this.request<DealSearchResponse, ErrorMessage>({
        path: `/api/crm/external/v1/deals/search/${substring}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name GetDealCounters
     * @summary Получение количества сделок по колонкам и статусам (счетчики)
     * @request GET:/api/crm/external/v1/deals/count
     */
    getDealCounters: (params: RequestParams = {}) =>
      this.request<DealCounterResponse, ErrorMessage>({
        path: `/api/crm/external/v1/deals/count`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name GetDeal
     * @summary Получение карточки сделки
     * @request GET:/api/crm/external/v1/deals/card
     */
    getDeal: (query: { id: string }, params: RequestParams = {}) =>
      this.request<DealCard, ErrorMessage>({
        path: `/api/crm/external/v1/deals/card`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Контакты
     * @name GetContactPage
     * @summary Получение списка контактов
     * @request GET:/api/crm/external/v1/contacts
     */
    getContactPage: (
      query?: { page?: number; size?: number },
      params: RequestParams = {}
    ) =>
      this.request<ContactPageResponse, ErrorMessage>({
        path: `/api/crm/external/v1/contacts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Контакты
     * @name SearchContacts
     * @summary Поиск контактов
     * @request GET:/api/crm/external/v1/contacts/search/{substring}
     */
    searchContacts: (substring: string, params: RequestParams = {}) =>
      this.request<ContactSearchResponse, ErrorMessage>({
        path: `/api/crm/external/v1/contacts/search/${substring}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Контакты
     * @name GetContact
     * @summary Получение карточки контакта
     * @request GET:/api/crm/external/v1/contacts/card
     */
    getContact: (query: { id: string }, params: RequestParams = {}) =>
      this.request<ContactCard, ErrorMessage>({
        path: `/api/crm/external/v1/contacts/card`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Комментарии
     * @name GetCommentPage
     * @summary Получение списка комментариев к сделке
     * @request GET:/api/crm/external/v1/comments
     */
    getCommentPage: (
      query?: {
        page?: number;
        size?: number;
        commentIds?: string[];
        dealId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<DealCommentPageResponse, ErrorMessage>({
        path: `/api/crm/external/v1/comments`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Комментарии
     * @name GetCommentCard
     * @summary Получение карточки комментария к сделке
     * @request GET:/api/crm/external/v1/comments/card
     */
    getCommentCard: (query: { id: string }, params: RequestParams = {}) =>
      this.request<DealCommentCard, ErrorMessage>({
        path: `/api/crm/external/v1/comments/card`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Задачи
     * @name DeleteTask
     * @summary Удаление задачи
     * @request DELETE:/api/crm/external/v1/tasks/delete
     */
    deleteTask: (data: TaskDeletionRequest, params: RequestParams = {}) =>
      this.request<TaskDeletionResponse, ErrorMessage>({
        path: `/api/crm/external/v1/tasks/delete`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Товары и услуги
     * @name DeleteProductAndService
     * @summary Удаление товара / услуги
     * @request DELETE:/api/crm/external/v1/dict/products-and-services/delete
     */
    deleteProductAndService: (
      data: ProductAndServiceDeletionRequest,
      params: RequestParams = {}
    ) =>
      this.request<ProductAndServiceDeletionResponse, ErrorMessage>({
        path: `/api/crm/external/v1/dict/products-and-services/delete`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name DeleteDeal
     * @summary Удаление сделок
     * @request DELETE:/api/crm/external/v1/deals/delete
     */
    deleteDeal: (data: DealDeletion, params: RequestParams = {}) =>
      this.request<DealDeletionResponse, ErrorMessage>({
        path: `/api/crm/external/v1/deals/delete`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Контакты
     * @name DeleteContact
     * @summary Удаление контакта
     * @request DELETE:/api/crm/external/v1/contacts/delete
     */
    deleteContact: (data: ContactDeletionRequest, params: RequestParams = {}) =>
      this.request<ContactDeletionResponse, ErrorMessage>({
        path: `/api/crm/external/v1/contacts/delete`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Комментарии
     * @name DeleteComment
     * @summary Удаление комментария к сделке
     * @request DELETE:/api/crm/external/v1/comments/delete
     */
    deleteComment: (
      data: DealCommentDeletionRequest,
      params: RequestParams = {}
    ) =>
      this.request<DealCommentDeletionResponse, ErrorMessage>({
        path: `/api/crm/external/v1/comments/delete`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
